<template>
  <Overlay :show="show">
    <main class="info-affirm">
      <header class="header">
        <img class="background" :src="background" />
        <div class="title1">
          <i class="iconfont icon-close" @click="onClose"></i>
          <h3 class="name">问卷调查</h3>
        </div>
      </header>
      <section class="content">
        <div class="text">
          为进一步提升四川省网络教研活动的质量，现对网络教研活动的开展做一个问卷调查，调查结果不会对您本人产生任何影响，请大家如实填写问卷，谢谢配合和支持!
        </div>
        <div class="btn confirm" @click="onJump">填写问卷</div>
      </section>
    </main>
  </Overlay>
</template>

<script>
import {Overlay} from 'vant'
export default {
  name: 'info-affirm',
  components: {
    Overlay
  },
  props: {
    show: {
      type: Boolean
    }
  },
  data() {
    return {
      background: require('../../assets/image/customization/info-affirm-background.png')
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  methods: {
    handleJumpUserinfo() {
      this.$router.push('/customization/user-info')
    },
    onJump() {
      window.location.href =
        'https://www.ecscc.net/zhxy//mobile/jump.html#/?formId=1031474292195865271&tenantId=0&orgId=493397513643102221&type=public&formName=网络教研活动问卷调查'
    },
    onClose() {
      this.$emit('on-close')
    }
  }
}
</script>

<style lang="scss" scoped>
.info-affirm {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  border-radius: 10px;
  background: #fff;
  .header {
    position: relative;
    width: 100%;
    height: 72px;
    border-radius: 10px 10px 0 0;
    .background {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      border-radius: 10px 10px 0 0;
      z-index: 9;
    }
    .title1 {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      text-align: center;
      line-height: 72px;
      color: #fff;
      border-radius: 10px 10px 0 0;
      z-index: 10;
      i {
        position: absolute;
        right: 15px;
        top: -15px;
        font-size: 21px;
      }
      .name {
        font-size: 17px;
        font-weight: 600;
      }
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 24px 28px;
    box-sizing: border-box;
    .text {
      font-size: 15px;
      color: #1a1a1a;
      line-height: 23px;
    }
    .btn {
      margin-top: 24px;
      width: 200px;
      height: 40px;
      border-radius: 25px;
      text-align: center;
      line-height: 40px;
      font-size: 15px;
      box-sizing: border-box;
      &.confirm {
        color: #fff;
        background: #007aff;
      }
      &.edit {
        border: 1px solid #e5e5e5;
        color: #1a1a1a;
      }
    }
  }
}
</style>
